import { createFileRoute } from '@tanstack/react-router'
import UpgradePlanPopup from '../../../../../../containers/UpgradePlanPopup'
import { plansContextSearchSchema } from '../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/_plans/upgrade/'
)({
  validateSearch: plansContextSearchSchema,
  component: UpgradePlanPopup
})
